const USER_LOGS_CREDENTIAL_CHANGES_URL = '/_exclusive/users/action-logs/credentials';

/**
 * https://blueprint.bukalapak.io/exclusive/t/users~user~action~log~get~exclusive~users~action-logs~credentials~changes
 * @param {string} param.startDate - start date 7 days earlier from date now
 * @param {string} param.enDate - date now
 * @returns {Promise}
 */
export const getCredentialChangeStatus = ($axios, { startDate = '', endDate = '' }) =>
  $axios.$get(`${USER_LOGS_CREDENTIAL_CHANGES_URL}/changes`, { params: { start_date: startDate, end_date: endDate } });
